<template>
  <div>
    <SummaryEvent v-if="summary" :event="event" />

    <DetailEvent v-else :event="event">
      <img
        v-if="event.wasAutomaticallyApproved()"
        src="@/assets/icons/logo.svg"
        class="tw-w-10 leavedates-header-logo"
        alt="leavedates-logo"
      />
    </DetailEvent>
  </div>
</template>

<script>
import ApprovedEvent from '@/components/requests/leave/events/ApprovedEvent'
import SummaryEvent from '@/components/requests/leave/timeline/SummaryEvent'
import DetailEvent from '@/components/requests/leave/timeline/DetailEvent'

export default {
  name: 'LeaveWasApproved',

  components: { SummaryEvent, DetailEvent },

  props: {
    event: {
      type: ApprovedEvent,
      required: true,
    },

    summary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
